// extracted by mini-css-extract-plugin
export default {"container":"SignUp_container__z+Lnx","description":"SignUp_description__yEBYX"};